import { CommApiInstance } from "Utils/CommApiInstance";

export interface CommuBrdPstdCmntItem {
    brdPstdCmntSno: number;
    cmntLvl: number;
    prntCmntSno: number;
    cmntCtxt: string;
    nickname: string;
    mineYn: string;
}

export interface CommuBrdPstdCmntApiResponse {
    apiHdr: {
        code: string;
        msg: string;
        respDtime: string;
        rqstTrxId: string;
        rqstDtime: string;
        lang: string;
        timeZone: string;
    };
    apiBody: {
        nowPageNo: number;
        nowPageCnt: number;
        totCnt: number;
        onePageSize: number;
        brdPstdCmntLst: CommuBrdPstdCmntItem[];
    };
}

const CommuBrdPstdCmntApi = async (
    brdCd:string,
    brdPstdSno:string,
    page:number,
) : Promise<CommuBrdPstdCmntApiResponse> => {
    return await CommApiInstance.post(`brd/BBO/${brdCd}/${brdPstdSno}/cmnt?page=${page}`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data as CommuBrdPstdCmntApiResponse);
}
export default CommuBrdPstdCmntApi;